import { CommandType, Monster } from '../types';
import { CommandWeightMap } from './weightedSelection';

/**
 * ステータスの基準値（平均的なモンスターの値）
 */
const STAT_BASELINE = {
  strength: 50,
  special: 50,
} as const;

/**
 * 偏差をモディファイア係数に変換するスケール
 * 控えめにしてワンパターン化を防ぐ
 */
const MODIFIER_SCALE = 0.008;

const MIN_MODIFIER = 0.6;
const MAX_MODIFIER = 1.8;

function clampModifier(value: number): number {
  return Math.max(MIN_MODIFIER, Math.min(MAX_MODIFIER, value));
}

/**
 * 自分モンスターの能力値に応じた重みモディファイア
 *
 * 自分のstrength/specialと基準値(50)の偏差に基づき、
 * WEAPON_ATTACK/SPECIAL_ATTACKの重みを連続的に調整する。
 *
 * - 自分のstrengthが低い → WEAPON_ATTACKを抑制（弱い武器攻撃を出しすぎない）
 * - 自分のspecialが高い → SPECIAL_ATTACKを強化
 * - 移動系・防御系コマンドは影響を受けない（1.0固定）
 *
 * 計算例（MODIFIER_SCALE=0.008）:
 * - シエル(strength=20): WEAPON_ATTACK → 1.0 + 0.008*(-30) = 0.76（抑制）
 * - ドルグ(strength=75): WEAPON_ATTACK → 1.0 + 0.008*(+25) = 1.20（強化）
 *
 * @param self 自分モンスター
 * @returns コマンドごとの重みモディファイア
 */
export function getSelfAbilityModifiers(self: Monster): CommandWeightMap {
  const strengthDev = self.stats.strength - STAT_BASELINE.strength;
  const specialDev = self.stats.special - STAT_BASELINE.special;

  return {
    [CommandType.WEAPON_ATTACK]: clampModifier(1.0 + MODIFIER_SCALE * strengthDev),
    [CommandType.SPECIAL_ATTACK]: clampModifier(1.0 + MODIFIER_SCALE * specialDev),
    [CommandType.ADVANCE]: 1.0,
    [CommandType.RETREAT]: 1.0,
    [CommandType.REFLECTOR]: 1.0,
    [CommandType.STANCE_A]: 1.0,
    [CommandType.STANCE_B]: 1.0,
  };
}
